import speakingurl from 'speakingurl'
import OtherProject, { NON_POWER_PROJECT_TYPES } from './OtherProject'

class TestCenterProject extends OtherProject {
  constructor (obj) {
    super(obj)

    this.type = 'TestCenter'
    this.name = obj.Owner
    this.owner = ''
    this.operator = ''
    this.id = speakingurl(`${this.name}`)

    this.city = obj.City
    this.website = obj.Website
    this.technology = obj.Technology

    this._type = NON_POWER_PROJECT_TYPES['TestCenter']
    this.typeShortName = this._type.shortName
    this.icon = this._type.icon
  }
}

export default TestCenterProject



// WEBPACK FOOTER //
// ./src/models/TestCenterProject.js